import React from 'react';
import { LiveOrHighlightOrBoth } from '../providerXcompetitonsXgames/types/HighlightOrLiveOrBoth.types';
import { Streamingpackage } from '../../../../interfaces/StreamingProvider.interface';
import { Game } from '../../../../interfaces/Games.interface';
import BCCoveredGames from './BCCoveredGames';

type RenderCoveredGamesProps = {
  mode: LiveOrHighlightOrBoth;
  liveCombi: {
    providers: Streamingpackage[];
    coveredGames: Game[];
    uncoveredGames: Game[];
    providerPackageCoverage: { [key: string]: Set<number> };
  };
  highlightCombi: {
    providers: Streamingpackage[];
    coveredGames: Game[];
    uncoveredGames: Game[];
    providerPackageCoverage: { [key: string]: Set<number> };
  };
  streamingPackages: Streamingpackage[];
  gamesFromSelectedTeams: Game[];
  totalCoveredGames: Game[];
  totalCoveredGames_HIGHLIGHT: Game[];
};

const RenderCoveredGames: React.FC<RenderCoveredGamesProps> = ({
  mode,
  liveCombi,
  highlightCombi,
  streamingPackages,
  gamesFromSelectedTeams,
  totalCoveredGames,
  totalCoveredGames_HIGHLIGHT,
}) => {
  if (mode === 'Live') {
    return (
      <BCCoveredGames
        bestProvider={liveCombi.providers}
        allProviders={streamingPackages}
        gamesFromSelectedTeams={gamesFromSelectedTeams}
        mode="Live"
        totalCoveredGames={totalCoveredGames}
        uncoveredGames={liveCombi.uncoveredGames}
        providerPackageCoverage={liveCombi.providerPackageCoverage}
        caption1="Covered live streams"
        caption2="Uncovered live games"
      />
    );
  }

  if (mode === 'Highlight') {
    return (
      <BCCoveredGames
        bestProvider={highlightCombi.providers}
        allProviders={streamingPackages}
        gamesFromSelectedTeams={gamesFromSelectedTeams}
        mode="Highlight"
        totalCoveredGames={totalCoveredGames_HIGHLIGHT}
        uncoveredGames={highlightCombi.uncoveredGames}
        providerPackageCoverage={highlightCombi.providerPackageCoverage}
        caption1="Covered Highlights"
        caption2="Uncovered Highlights"
      />
    );
  }

  // Default: Show both Live and Highlight
  return (
    <>
      <BCCoveredGames
        bestProvider={liveCombi.providers}
        allProviders={streamingPackages}
        gamesFromSelectedTeams={gamesFromSelectedTeams}
        mode="Live"
        totalCoveredGames={totalCoveredGames}
        uncoveredGames={liveCombi.uncoveredGames}
        providerPackageCoverage={liveCombi.providerPackageCoverage}
        caption1="Covered live streams"
        caption2="Uncovered live games"
      />
      <BCCoveredGames
        bestProvider={highlightCombi.providers}
        allProviders={streamingPackages}
        gamesFromSelectedTeams={gamesFromSelectedTeams}
        mode="Highlight"
        totalCoveredGames={totalCoveredGames_HIGHLIGHT}
        uncoveredGames={highlightCombi.uncoveredGames}
        providerPackageCoverage={highlightCombi.providerPackageCoverage}
        caption1="Covered Highlights"
        caption2="Uncovered Highlights"
      />
    </>
  );
};

export default RenderCoveredGames;
